// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface ICheckEstimationRequestExistsResponseSchema {
  /** Состояние кнопки для стейта первого блока заявки **/
  action: EAction;
  /** Есть ли ответ на «причина» **/
  dealTypeExExists: boolean;
  /** Есть ли телефон **/
  phoneExists: boolean;
}
export enum EAction {
  /** Показать состояние с кнопкой-редиректом на новую заявку риелтору  **/
  'RealtorForm' = 'realtorForm',
  /** Заявка отправлена **/
  'RequestSent' = 'requestSent',
  /** Показать состояние с кнопкой на оставить заявку в листинг **/
  'SendRequest' = 'sendRequest',
}
